module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/industry/industry.component.css
// module id = ./src/app/industry/industry.component.css
// module chunks = main